/**
 * Explore page constants
 * Centralized constants for marker types, view modes, and filter keys
 */

// Marker type keys (matches data from API)
// These are used both for:
// 1. Checking marker.type in data
// 2. Filter state keys (pluralized in state structure)
export const MARKER_TYPES = {
  HEART: 'heart',
  SAVED_HEART: 'heartSaved',
  VISITED_HEART: 'heartVisited',
  SAVED_VISITED_HEART: 'heartSavedVisited',
  COMMUNITY: 'community',
  ARTIST: 'artist',
  ATTRACTION: 'attraction',
  EVENT: 'event',
  PROMOTION: 'promotion',
};

export const MARKER_Z_INDEX = {
  [MARKER_TYPES.SAVED_VISITED_HEART]: 1150,
  [MARKER_TYPES.VISITED_HEART]: 1100,
  [MARKER_TYPES.SAVED_HEART]: 1050,
  [MARKER_TYPES.HEART]: 1000,
  [MARKER_TYPES.PROMOTION]: 700,
  [MARKER_TYPES.EVENT]: 600,
  [MARKER_TYPES.ATTRACTION]: 500,
  [MARKER_TYPES.ARTIST]: 400,
  [MARKER_TYPES.COMMUNITY]: 300,
};

export const MARKER_ICON_SIZE = {
  heart: { default: { width: 44, height: 44 }, selected: { width: 54, height: 54 } },
  heartSaved: { default: { width: 44, height: 44 }, selected: { width: 54, height: 54 } },
  heartVisited: { default: { width: 44, height: 44 }, selected: { width: 54, height: 54 } },
  heartSavedVisited: { default: { width: 44, height: 44 }, selected: { width: 54, height: 54 } },
  community: { default: { width: 44, height: 44 }, selected: { width: 54, height: 54 } },
  artist: { default: { width: 44, height: 44 }, selected: { width: 54, height: 54 } },
  attraction: { default: { width: 44, height: 44 }, selected: { width: 54, height: 54 } },
  event: { default: { width: 44, height: 44 }, selected: { width: 54, height: 54 } },
  promotion: { default: { width: 44, height: 44 }, selected: { width: 54, height: 54 } },
};

/** Returns true for any heart variant (regular, saved, or visited) */
export function isHeartType(type) {
  return (
    type === MARKER_TYPES.HEART ||
    type === MARKER_TYPES.SAVED_HEART ||
    type === MARKER_TYPES.VISITED_HEART ||
    type === MARKER_TYPES.SAVED_VISITED_HEART
  );
}

// Filter state keys (pluralized versions for state structure)
// maps to: filters.hearts, filters.communities, etc.
export const FILTER_KEYS = {
  HEARTS: 'hearts',
  COMMUNITIES: 'communities',
  ARTISTS: 'artists',
  ATTRACTIONS: 'attractions',
  EVENTS: 'events',
  PROMOTIONS: 'promotions',
};

// View mode keys
export const VIEW_MODES = {
  MAP: 'map',
  LIST: 'list',
};

// Nested filter keys (for communities and attractions)
export const NESTED_FILTER_KEYS = {
  ALL: 'all',
  SELECTED: 'selected',
};

// Promotion category keys
export const PROMOTION_CATEGORIES = {
  ALL: 'all',
  DINING: 'dining',
  ATTRACTIONS: 'attractions',
  SPORTS: 'sports',
  ARTS: 'arts',
};

export const HEART_YEAR_STATUS = {
  ACTIVE: 1,
  ARCHIVED: 2,
};
